import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
	{
		path: '',
		loadChildren: () => import('./modules/totem/totem.module').then(m => m.TotemModule),
	},

	{
		path: 'panel',
		loadChildren: () => import('./modules/panel/panel.module').then(m => m.PanelModule),
	},

	{
		path: '',
		loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { useHash: false })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
